'use client';

import type { ListCollection } from '@skin-seoul/design-system';
import { Box, Flex, Select, Text } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
interface ProductFinderSelectProps {
  label: string;
  collection: ListCollection<{
    label: string;
    value: string;
  }>;
  value: string[];
  onValueChange: (details: {
    value: string[];
  }) => void;
}
const ProductFinderSelect = ({
  label,
  collection,
  value,
  onValueChange
}: ProductFinderSelectProps) => {
  return <Flex flexDirection="column" width="100%" data-sentry-element="Flex" data-sentry-component="ProductFinderSelect" data-sentry-source-file="ProductFinderSelect.tsx">
      <Select.Root size="xs" multiple={false} collection={collection} deselectable={false} value={value} onValueChange={onValueChange} flexDirection="column" justifyContent="space-between" gap={{
      base: 6,
      desktop: 4
    }} alignItems={{
      tablet: 'center',
      desktop: 'flex-start'
    }} width="100%" data-sentry-element="Select.Root" data-sentry-source-file="ProductFinderSelect.tsx">
        <Select.HiddenSelect data-sentry-element="Select.HiddenSelect" data-sentry-source-file="ProductFinderSelect.tsx" />
        <Select.Label textStyle="paragraph.medium" fontWeight="regular" color="neutral.100" width="100%" data-sentry-element="Select.Label" data-sentry-source-file="ProductFinderSelect.tsx">
          {label}
        </Select.Label>
        <Box paddingBottom={3} borderBottom="1px solid" borderColor="neutral.200" width="100%" data-sentry-element="Box" data-sentry-source-file="ProductFinderSelect.tsx">
          <Select.Control borderRadius={0} width="100%" data-sentry-element="Select.Control" data-sentry-source-file="ProductFinderSelect.tsx">
            <Select.Trigger border="none" minH="22px" padding={0} data-sentry-element="Select.Trigger" data-sentry-source-file="ProductFinderSelect.tsx">
              <Select.ValueText textStyle={{
              base: 'paragraph.medium',
              tablet: 'paragraph.large'
            }} color="generic.0" lineClamp={1} fontWeight="medium" wordBreak="break-all" data-sentry-element="Select.ValueText" data-sentry-source-file="ProductFinderSelect.tsx" />
            </Select.Trigger>
            <Select.IndicatorGroup data-sentry-element="Select.IndicatorGroup" data-sentry-source-file="ProductFinderSelect.tsx">
              <Select.Indicator data-sentry-element="Select.Indicator" data-sentry-source-file="ProductFinderSelect.tsx">
                <LucideIcon name="ChevronDown" boxSize={7} strokeWidth="1px" color="generic.0" data-sentry-element="LucideIcon" data-sentry-source-file="ProductFinderSelect.tsx" />
              </Select.Indicator>
            </Select.IndicatorGroup>
          </Select.Control>
        </Box>
        <Select.Positioner data-sentry-element="Select.Positioner" data-sentry-source-file="ProductFinderSelect.tsx">
          <Select.Content backgroundColor="generic.0" borderRadius="8px" boxShadow="0 4px 6px rgba(0,0,0,0.1)" maxHeight="300px" overflowY="auto" data-sentry-element="Select.Content" data-sentry-source-file="ProductFinderSelect.tsx">
            {collection.items.map(option => <Select.Item key={option.value} item={option} padding={3} color="neutral.700" textStyle="paragraph.medium" _hover={{
            backgroundColor: 'neutral.50',
            color: 'neutral.600'
          }} _checked={{
            backgroundColor: 'primary.100',
            color: 'primary.600'
          }} transition="all 0.2s">
                <Text wordBreak="break-all" textStyle="paragraph.medium" lineClamp={1}>
                  {option.label}
                </Text>
                <Select.ItemIndicator />
              </Select.Item>)}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </Flex>;
};
export default ProductFinderSelect;